import React, { useEffect, useState } from "react";
import moment from "moment";
import { FaLayerGroup } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import { isNil } from "ramda";
import { monitoringQueueEntryType } from "../../../../../../../prop-types/monitoringQueueEntryTypes";

import {
  MONITORING_QUEUE_ENTRY_TYPES,
  TABLE_HEADER_DROPDOWN_VALUES,
  watchListMatchStatusOptions,
  displayTypeLabel,
} from "../../../../../constants/monitoringQueueEntryConstants";

import { CLIENT_SCORING_RESULT_SCORING_STATUS } from "../../../../../constants/clientScoringResultConstants";
import "./monitoringQueueEntryTableRow.css";
import { CustomCheckBox } from "../../../../../../../components/common/CusomMUIComponents";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  filtersSelector,
  selectTableCheckboxChecked,
  selectTableHeaderDropdownValue,
} from "../../../../../selectors";
import { Link } from "@material-ui/core";

const MonitoringQueueEntriesTableRow = ({
  entry,
  selectEntry,
  selectedEntries,
  deselectedEntries,
  organizationInfo,
}) => {
  const [isActive, setIsActive] = useState(true);
  const history = useHistory();
  const { type } = useSelector(filtersSelector);
  const tableCheckboxChecked = useSelector(selectTableCheckboxChecked);
  const tableHeaderDropdownValue = useSelector(selectTableHeaderDropdownValue);

  useEffect(() => {
    if (entry) {
      isActiveCheck(entry);
    }
  }, [entry]);

  function isActiveCheck(entry) {
    switch (entry.type) {
      case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH:
        setIsActive(true);
        break;
      case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH:
        setIsActive(entry.clientRegularSearchingResult.client.isActive);
        break;
      case MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING:
      case MONITORING_QUEUE_ENTRY_TYPES.API_SCORING:
      case MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING:
        setIsActive(entry.clientScoringResult.client.isActive);
        break;
      case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO:
        setIsActive(entry.clientNegativeMediaCheckResult.client.isActive);
        break;
      case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED:
        setIsActive(entry.clientNegativeMediaCheckResult.client.isActive);
        break;
      default:
    }
  }

  useEffect(() => {
    if (entry) {
      isActiveCheck(entry);
    }
  }, [entry]);

  function getAdditionOrganizationPropertyValueByType(type) {
    var client = null;
    switch (entry.type) {
      case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH:
        client = entry.clientRegularSearchingResult.client;
        break;
      case MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING:
      case MONITORING_QUEUE_ENTRY_TYPES.API_SCORING:
      case MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING:
        client = entry.clientScoringResult.client;
        break;
      case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO:
        client = entry.clientNegativeMediaCheckResult.client;
        break;
      default:
    }
    return client
      ? client.clientParams.filter((a) => a.name === type).length > 0
        ? client.clientParams.filter((a) => a.name === type)[0].value
        : ""
      : "";
  }

  function hasNegativeMedia(clientNegativeMediaCheckResult) {
    if (clientNegativeMediaCheckResult.url) {
      return entry.clientNegativeMediaCheckResult.url;
    }
    if (clientNegativeMediaCheckResult.dataJson) {
      var data = JSON.parse(clientNegativeMediaCheckResult.dataJson);
      return data.IsPresented;
    }

    return false;
  }

  const decision = () => {
    var watchListMatches = [];

    if (entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH) {
      watchListMatches =
        entry.clientRegularSearchingResult.watchListMatchesList;
    }
    if (
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.API_SCORING ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING
    ) {
      return Object.keys(CLIENT_SCORING_RESULT_SCORING_STATUS).find(
        (key) =>
          CLIENT_SCORING_RESULT_SCORING_STATUS[key] ===
          entry.clientScoringResult.scoringStatus,
      );
    }
    // if (entry.type === MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING) {
    //   const labels = [];
    //   const matchesList = entry.clientScoringResult.watchListMatchesList;
    //   if (Array.isArray(matchesList)) {
    //     matchesList.forEach((item) => {
    //       if (item.watchListSearchingDecisionDto) {
    //         const opt = watchListMatchStatusOptions.find(
    //           ({ key }) => key === item.watchListSearchingDecisionDto.type
    //         );

    //         if (opt.label && !labels.includes(opt.label)) {
    //           labels.push(opt.label+"dicks");
    //         }
    //       }
    //     });
    //   }
    //   return labels.join(", ");
    // }
    if (watchListMatches && watchListMatches.length > 0) {
      var arr = watchListMatches
        .filter((a) => a.watchListSearchingDecisionDto)
        .map(
          (a) =>
            watchListMatchStatusOptions.find(
              (option) => option.key === a.watchListSearchingDecisionDto.type,
            ).label,
        );

      if (watchListMatches.length !== arr.length) {
        return "";
      }

      arr = arr.map((a) => a.trim());
      var set = new Set(arr);
      return Array.from(set).join(",");
    }
    // eslint-disable-next-line
    var negativemediatype = 1;
    var isPresented = false;
    if (
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
    ) {
      negativemediatype = 2;
    }
    if (
      entry.clientNegativeMediaCheckResult &&
      entry.clientNegativeMediaCheckResult.dataJson
    ) {
      var data = JSON.parse(entry.clientNegativeMediaCheckResult.dataJson);
      isPresented = data.IsPresented;
    }

    var result = "";

    if (
      isNil(entry.clientNegativeMediaCheckResult) ||
      isNil(entry.clientNegativeMediaCheckResult.client) ||
      !entry.clientNegativeMediaCheckResult.client
        .negativeMediaIgnoringProperties ||
      (entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO &&
        !entry.clientNegativeMediaCheckResult.url) ||
      (entry.type ===
        MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED &&
        !isPresented)
    ) {
      result = "";
    } else {
      let decisionType = entry.clientNegativeMediaCheckResult
        .negativeMediaSearchingDecision
        ? entry.clientNegativeMediaCheckResult.negativeMediaSearchingDecision
            .type
        : null;
      let match = null;

      for (let i = 0; i < watchListMatchStatusOptions.length; i++) {
        if (watchListMatchStatusOptions[i].key === decisionType) {
          match = watchListMatchStatusOptions[i];
          break;
        }
      }
      // If no match found, default to the first option: In Review
      result = match ? match.label : "Pending";
    }

    return result;
  };

  const changeSelection = (data) => {
    selectEntry(data);
  };

  const checked = () => {
    return (
      selectedEntries.indexOf(entry.id) !== -1 ||
      (tableHeaderDropdownValue === TABLE_HEADER_DROPDOWN_VALUES.ALL &&
        tableCheckboxChecked &&
        deselectedEntries.indexOf(entry.id) === -1)
    );
  };

  const defineWatchlistMatch = () => {
    if (entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH) {
      var result = "No Match";
      if (!isNil(entry.clientRegularSearchingResult.watchListMatches)) {
        var arr =
          entry.clientRegularSearchingResult.watchListMatches.split(",");
        arr = arr.map((a) => a.trim());
        var set = new Set(arr);
        result = <span className="red">{Array.from(set).join(",")}</span>;
      }
      return result;
    }
    if (entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH) {
      return !isNil(entry.clientManualSearchingResult.watchListMatches) ? (
        <span className="red">
          {entry.clientManualSearchingResult.watchListMatches}
        </span>
      ) : (
        "No Match"
      );
    }
    if (
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
    ) {
      return (
        <span
          className={
            entry.clientNegativeMediaCheckResult.url ||
            entry.clientNegativeMediaCheckResult.dataJson
              ? "red"
              : "green"
          }
        >
          {hasNegativeMedia(entry.clientNegativeMediaCheckResult)
            ? "Yes"
            : "No"}
        </span>
      );
    }
    if (
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.API_SCORING ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING
    ) {
      if (entry.clientScoringResult.scoreCardRiskProfileValue === 5) {
        return (
          <span className="red">
            {entry.clientScoringResult.scoreCardRiskProfileName}
          </span>
        );
      }
      if (entry.clientScoringResult.scoreCardRiskProfileValue === 3) {
        return (
          <span className="orange">
            {entry.clientScoringResult.scoreCardRiskProfileName}
          </span>
        );
      }
      if (entry.clientScoringResult.scoreCardRiskProfileValue === 1) {
        return (
          <span className="green">
            {entry.clientScoringResult.scoreCardRiskProfileName}
          </span>
        );
      }
    }
    return "";
  };

  const defineActionStatusColor = (entry) => {
    if (
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.API_SCORING ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
      entry.type ===
        MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED ||
      entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH
    ) {
      var list = [];
      // eslint-disable-next-line
      var negativemediatype = 1;
      if (
        entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
      ) {
        negativemediatype = 2;
      }

      switch (entry.type) {
        case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH:
          list = entry.clientManualSearchingResult.watchListMatchesList;
          break;
        case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH:
          list =
            entry.clientRegularSearchingResult.watchListMatchesList ||
            entry.clientRegularSearchingResult.watchListSearchingDecisionDto;
          break;
        case MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING:
        case MONITORING_QUEUE_ENTRY_TYPES.API_SCORING:
        case MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING:
          list = entry.clientScoringResult.watchListMatchesList;
          break;
        case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO:
        case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED:
          if (
            entry.clientNegativeMediaCheckResult.negativeMediaSearchingDecision
          ) {
            list = [
              entry.clientNegativeMediaCheckResult
                .negativeMediaSearchingDecision,
            ];
          }
          break;
        default:
      }
      var inactive = null;
      var errors = null;
      var warnings = null;
      var success = null;
      var base = false;

      if (entry.clientNegativeMediaCheckResult !== null) {
        if (
          entry.clientNegativeMediaCheckResult.url === null &&
          entry.clientNegativeMediaCheckResult.dataJson === null
        ) {
          base = true;
        } else {
          success = list.length > 0;
          warnings = entry.actionStatus === 2;
          errors = true;
        }
        if (!entry.clientNegativeMediaCheckResult.client.isActive) {
          inactive = !entry.clientNegativeMediaCheckResult.client.isActive;
        }
      } else if (entry.clientScoringResult !== null) {
        if (entry.clientScoringResult.scoreCardRiskProfileValue !== 5) {
          base = true;
        }
        success =
          entry.clientScoringResult.scoreCardRiskProfileValue === 5 &&
          entry.clientScoringResult.scoringStatus >
            CLIENT_SCORING_RESULT_SCORING_STATUS.Escalated &&
          !list.find(
            (wm) =>
              isNil(wm.watchListSearchingDecisionDto) ||
              wm.watchListSearchingDecisionDto.createDate === undefined,
          );

        success =
          entry.clientScoringResult.scoringStatus ===
            CLIENT_SCORING_RESULT_SCORING_STATUS.RejectedHighRisk ||
          entry.clientScoringResult.scoringStatus ===
            CLIENT_SCORING_RESULT_SCORING_STATUS.ApprovedHighRisk;

        warnings =
          entry.clientScoringResult.scoreCardRiskProfileValue === 5 &&
          entry.actionStatus === 2 &&
          (entry.clientScoringResult.scoringStatus ===
            CLIENT_SCORING_RESULT_SCORING_STATUS.Pending ||
            entry.clientScoringResult.scoringStatus ===
              CLIENT_SCORING_RESULT_SCORING_STATUS.Escalated);

        errors = entry.clientScoringResult.scoreCardRiskProfileValue === 5;

        if (!entry.clientScoringResult.client.isActive) {
          inactive = !entry.clientScoringResult.client.isActive;
        }
      } else if (entry.clientRegularSearchingResult !== null) {
        base = list.length === 0;
        success = !list.find(
          (wm) =>
            isNil(wm.watchListSearchingDecisionDto) ||
            wm.watchListSearchingDecisionDto.createDate === undefined,
        );
        warnings = entry.actionStatus === 2;
        errors = true;
        if (!entry.clientRegularSearchingResult.client.isActive) {
          inactive = !entry.clientRegularSearchingResult.client.isActive;
        }
      }
    }
    return defineColorByChecks(inactive, errors, warnings, success, base);
  };

  const defineColorByChecks = (
    inactive,
    errors,
    warnings,
    success,
    base = true,
  ) => {
    if (inactive) {
      return "#9A9A9A";
    }
    if (base) {
      return "cornflowerblue";
    }
    if (success) {
      return "#2de67d";
    }
    if (warnings) {
      return "#f6bc2b";
    }
    if (errors) {
      return "#d82222";
    }
    return "cornflowerblue";
  };

  return (
    <React.Fragment>
      <tr
        id={checked() ? "checked-row" : ""}
        className={isActive ? "" : "monitoring-queue-inactive-overlay"}
      >
        <td className="empty-td"></td>
        <td className="pt-0 pb-0">
          <div>
            <CustomCheckBox
              id={entry.id}
              name="mq-entry"
              onChange={(e) => changeSelection(e)}
              checked={checked()}
            />
          </div>
        </td>
        <td>
          {displayTypeLabel({
            ...entry,
            ...entry.clientRegularSearchingResult,
          })}
        </td>
        <td>
          {moment.utc(entry.createDate).local().format("DD.MM.YYYY HH:mm:ss")}
        </td>
        <td>
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH
            ? entry.clientManualSearchingResult.clientManualSearchingParams.find(
                (sp) => sp.name === "Type",
              ).value
            : ""}
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH
            ? entry.clientRegularSearchingResult.client.type
            : ""}
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.API_SCORING ||
          entry.type === MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING ||
          entry.type === MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING
            ? entry.clientScoringResult.client.type
            : ""}
          {(entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
            entry.type ===
              MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED) &&
            entry.clientNegativeMediaCheckResult.client.type}
        </td>
        <td className="possible-long-text">
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH
            ? entry.clientRegularSearchingResult.client.clientParams.find(
                (sp) => sp.name === "Client",
              ).value
            : ""}
          {entry.type ===
            MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH &&
          entry.clientManualSearchingResult.clientManualSearchingParams.find(
            (sp) => sp.name === "Type",
          ).value === "Person"
            ? `${
                entry.clientManualSearchingResult.clientManualSearchingParams.find(
                  (sp) => sp.name === "FullName",
                ).value
              } `
            : ""}
          {entry.type ===
            MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH &&
          entry.clientManualSearchingResult.clientManualSearchingParams.find(
            (sp) => sp.name === "Type",
          ).value === "Company"
            ? `${
                entry.clientManualSearchingResult.clientManualSearchingParams.find(
                  (sp) => sp.name === "FullName",
                ).value
              }`
            : ""}
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.API_SCORING ||
          entry.type === MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING ||
          entry.type === MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING
            ? entry.clientScoringResult.client.clientParams.find(
                (sp) => sp.name === "Client",
              ).value
            : ""}
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
          entry.type ===
            MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
            ? entry.clientNegativeMediaCheckResult.client.clientParams.find(
                (sp) => sp.name === "Client" || sp.name === "FullName",
              ).value
            : ""}
        </td>
        <td>
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH
            ? entry.clientRegularSearchingResult.client.clientParams.find(
                (sp) => sp.name === "EGN_UCN",
              ).value
            : ""}
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.API_SCORING ||
          entry.type === MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING ||
          entry.type === MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING
            ? entry.clientScoringResult.client.clientParams.find(
                (sp) => sp.name === "EGN_UCN",
              ).value
            : ""}
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
          entry.type ===
            MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
            ? entry.clientNegativeMediaCheckResult.client.clientParams.find(
                (sp) => sp.name === "EGN_UCN",
              ).value
            : ""}
        </td>
        <td>
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH
            ? entry.clientRegularSearchingResult.client.offerId
            : ""}
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.API_SCORING ||
          entry.type === MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING ||
          entry.type === MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING
            ? entry.clientScoringResult.client.offerId
            : ""}
          {entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
          entry.type ===
            MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
            ? entry.clientNegativeMediaCheckResult.client.offerId
            : ""}
        </td>
        <td>
          {entry.type ===
          MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
            ? "Semantic Negative Media"
            : entry.type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO
              ? "Negative media"
              : isNil(entry.clientScoringResult)
                ? ""
                : entry.clientScoringResult.scoreCardRiskProfileValue > 1 &&
                    entry.clientScoringResult.scoreCardRiskFactorNames
                  ? entry.clientScoringResult.scoreCardRiskFactorNames
                      .split(",")
                      .join(", ")
                  : ""}
        </td>
        <td>
          {!isNil(entry.clientNegativeMediaCheckResult)
            ? hasNegativeMedia(entry.clientNegativeMediaCheckResult)
              ? "Yes"
              : "No"
            : isNil(entry.clientScoringResult)
              ? ""
              : entry.clientScoringResult.scoreCardRiskProfileValue > 1 &&
                  entry.clientScoringResult.clientParamValues
                ? entry.clientScoringResult.clientParamValues
                    .split(",")
                    .join(", ")
                : ""}
        </td>
        <td>{defineWatchlistMatch()}</td>
        <td>{decision()}</td>
        {organizationInfo &&
          organizationInfo.additionalOrganizationProperties &&
          organizationInfo.additionalOrganizationProperties.map((element) => {
            return (
              <td>
                {getAdditionOrganizationPropertyValueByType(element.name)}
              </td>
            );
          })}
        <td className="center pt-0 pb-0">
          <Actions />
        </td>
        <td className="empty-td"></td>
      </tr>
    </React.Fragment>
  );

  function Actions() {
    return (
      <Link
        target="_blank" // here
        style={!isActive ? { pointerEvents: "none" } : null}
        // to={routesConfig.monitoringQueueEntryDetailsPage.path.replace(
        //   ":id",
        //   entry.id,
        // )}
      >
        <ReactTooltip id="details-icon" type="info">
          <span>Details</span>
        </ReactTooltip>
        <FaLayerGroup
          onClick={() =>
            history.push(
              `?monitoringQueueEntryDetails&entryID=${entry.id}&type=${type}`,
            )
          }
          size="1.3em"
          data-tip
          data-for="details-icon"
          color={defineActionStatusColor(entry)}
        />
      </Link>
    );
  }
};
MonitoringQueueEntriesTableRow.propTypes = {
  entry: monitoringQueueEntryType,
};

export default MonitoringQueueEntriesTableRow;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-form/table/row/MonitoringQueueEntryTableRow.jsx